export function isValidNumber(val: unknown): val is number {
  return typeof val === 'number' && !isNaN(val) && val > 0;
}

export function convertDimensionToFeet(value: number, unit: string): number {
  switch (unit) {
    case 'Inch':
      return value / 12;
    case 'Foot':
      return value;
    case 'Yard':
      return value * 3;
    case 'Centimeter':
      return value / 30.48;
    case 'Meter':
      return value * 3.28084;
    case 'Millimeter':
      return value / 304.8;
    default:
      return value / 12;
  }
}

export function convertWeightToPounds(value: number, unit: string): number {
  switch (unit) {
    case 'Pound':
      return value;
    case 'Kilogram':
      return value * 2.20462;
    case 'Tonne':
      return value * 2204.62262;
    case 'Ounce':
      return value / 16;
    case 'Ton':
      return value * 2000;
    case 'Gram':
      return value * 0.00220462;
    case 'Long Ton':
      return value * 2240;
    default:
      return value;
  }
}
